import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { userProfile } from 'utils/auth';
import { rolesEnum } from './data/type';

// Special route for AI Avatar Layout - Based on old_layout flag from user token
export const AIAvatarRoute = ({ component: Component, ...rest }: any) => {
  const user = userProfile(false);

  if (!user || !Object.keys(user).length) {
    return <Redirect to="/login" />;
  }

  // Check old_layout flag from user token
  // If old_layout is false, user should use NewAIAvatarLayout
  const oldLayout = user?.old_layout !== undefined ? user.old_layout : true; // Default to true if not present
  
  if (oldLayout === false) {
    // User should use NewAIAvatarLayout, allow access
    return <Route component={Component} {...rest} />;
  }

  // If old_layout is true, user should use blue layout, redirect to homepage
  return <Redirect to="/" />;
};

// Check if user should be restricted to AI Avatar Layout only
// This is now based on old_layout flag, but kept for backward compatibility
export const shouldRestrictToAILayout = (userRoles: string[]): boolean => {
  // Check old_layout flag from user token
  const user = userProfile(false);
  if (user && user.old_layout !== undefined) {
    return user.old_layout === false; // If old_layout is false, restrict to AI Layout
  }
  
  // Fallback to role-based check for backward compatibility (only if old_layout is not set)
  return userRoles.includes(rolesEnum.betaPerformanceManager) || 
         userRoles.includes(rolesEnum.contentManager);
};


